import * as React from 'react';
import {Theme} from 'constants/theme';

export interface TextProps {
  theme?: Theme;
}

export class Text extends React.Component<TextProps, {}> {
  public static theme = Theme;
  public render() {
    const { theme, children } = this.props;
    const classes = theme ? `${theme}` : '';

    return (
      <span className={classes}>{children}</span>
    );
  }
}
